import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { BreadcrumbTexts } from "constant/BiPortalConstants";

export interface ShiftData {
  shiftId?: number;
  blockId?: number;
  shiftName?: string;
  availableClientCount: number;
  availableDays: number[];
  startTime: string;
  endTime: string;
  blockIds?: string;
  daysOfWeek: string;
  totalClientCount: number;
}

interface RequestPopOverProps {
  requestType: string;
  selectedShifts: number[];
  shiftsData: ShiftData[];
  onCancel: () => void;
  onStartRequest: (selectedShiftData: ShiftData[]) => void;
}

const RequestPopOver: React.FC<RequestPopOverProps> = ({ 
  requestType,
  selectedShifts, 
  shiftsData,
  onCancel, 
  onStartRequest 
}) => {
  if (selectedShifts.length === 0) {
    return null;
  }

  const getSelectedShiftData = () => {
    return shiftsData.filter(shift => {
      const cardId = shift.shiftId || shift.blockId;
      return cardId !== undefined && selectedShifts.includes(cardId);
    });
  };

  const handleStartRequest = () => {
    const selectedShiftData = getSelectedShiftData();
    onStartRequest(selectedShiftData);
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: { xs: "16px", sm: "16px", md: "96px" },
        right: { xs: "16px", sm: "16px", md: "24px" },
        backgroundColor: "#FFFFFF",
        borderTop: "1px solid #E0E0E0",
        padding: { xs: "16px 20px", sm: "20px 24px" },
        boxShadow: "0px -2px 8px rgba(0, 0, 0, 0.1)",
        zIndex: 1000,
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          color: "#333333",
          mb: 1,
          fontSize: { xs: "16px", sm: "18px" },
        }}
      >
        Start Request
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "13px", sm: "14px" },
          lineHeight: 1.4,
          mb: 2,
        }}
      >
        If you'd like to add these times to your <Box component="span" sx={{ fontWeight: 600 }}>{requestType === BreadcrumbTexts.setShift ? BreadcrumbTexts.setShift : BreadcrumbTexts.additionalAvailability}</Box>, you can submit a request. Once you submit, you won't be able to edit the request.
      </Typography>
      <Box sx={{ display: "flex", gap: 1.5, alignItems: "center", justifyContent: "flex-end" }}>
        <Button
          variant="text"
          onClick={onCancel}
          sx={{
            color: "#10389A",
            textTransform: "none",
            fontSize: { xs: "14px", sm: "16px" },
            fontWeight: 500,
            padding: { xs: "10px 20px", sm: "12px 24px" },
            borderRadius: "4px",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#F8F5FF",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleStartRequest}
          variant="contained"
          sx={{
            backgroundColor: "#10389A",
            color: "#FFFFFF",
            border: "2px solid #10389A",
            textTransform: "none",
            fontSize: { xs: "14px", sm: "16px" },
            fontWeight: 500,
            // padding: { xs: "10px 20px", sm: "12px 24px" },
            borderRadius: "4px",
            transition: "all 0.2s ease",
            "&:hover": {
              backgroundColor: "#0c2a75",
              borderColor: "#0c2a75",
            },
          }}
        >
          Start Request
        </Button>
      </Box>
    </Box>
  );
};

export default RequestPopOver;